<template>
  <a-select
    show-search
    :mode="mode"
    v-model="associatesProxy"
    :autoClearSearchValue="false"
    :allow-clear="true"
    :loading="loadingAssociated"
    :filter-option="false"
    :disabled="disabled"
    :placeholder="loadingAssociated ? 'Loading...' : 'Select Associate'"
    @search="searchAssociates"
    @focus="focusAssociates"
    @blur="blurAssociates"
  >
    <a-select-option v-for="associate in users" :key="associate.id" :value="associate.id">
      <a-tooltip placement="left">
        <template #title>
          <span>{{ getTagStatus(associate.work_status, associate.termination?.type).title }}</span>
        </template>
        <a-badge :color="getTagStatus(associate.work_status, associate.termination?.type).color" />
      </a-tooltip>
      {{ `[${associate.associate_number}] ${associate.first_name} ${associate.last_name}` }}
    </a-select-option>
    <template slot="dropdownRender" slot-scope="menu">
      <a-divider style="margin: 0" />
      <a-spin tip="Loading..." :spinning="loadingAssociated">
        <v-nodes :vnodes="menu" />
      </a-spin>
    </template>
  </a-select>
</template>

<script>
import { debounce } from '@/helpers/debounce'
import { getAssociateStatus } from '@/store/modules/profile/utils'
import VNodes from '@/components/ui/v-nodes.vue'
import { Badge, Divider, notification, Select, Spin, Tooltip } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const {
  mapState: searchState,
  mapActions: searchActions,
  mapMutations: searchMutation
} = createNamespacedHelpers('search')

export default {
  components: {
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-divider': Divider,
    'a-tooltip': Tooltip,
    'a-badge': Badge,
    'a-spin': Spin,
    VNodes
  },
  props: {
    value: {
      type: Array,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingAssociated: false,
      includeDisabled: true,

      searchQuery: ''
    }
  },
  watch: {
    searchQuery: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== '') this.fetchAssociates()
        }
      },
      immediate: true
    }
  },
  computed: {
    ...searchState({
      users: state => state.users
    }),

    mode() {
      return 'multiple'
    },

    associatesProxy: {
      get() {
        if (this.loadingAssociated) {
          return undefined
        }

        return this.value.map(el => Number(el))
      },
      set(value) {
        if (value === undefined) {
          this.searchQuery = ''

          this.$emit('update:value', [])

          return
        }

        this.$emit('update:value', value)
      }
    }
  },
  methods: {
    ...searchActions(['getUsers']),
    ...searchMutation(['setUsers']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    handleCheck(e) {
      this.includeDisabled = e.target.checked
    },

    getTagStatus(work_status, terminationType) {
      return getAssociateStatus(work_status, terminationType)
    },

    searchAssociates: debounce(function (value) {
      this.searchQuery = value
    }, 1000),

    focusAssociates() {
      this.searchQuery = ''
    },

    blurAssociates() {
      this.searchQuery = ''
    },

    addAssociate() {
      this.$emit('add')
    },

    // async calls

    async fetchAssociates() {
      this.loadingAssociated = true
      let skipFinally = false
      try {
        await this.getUsers({
          query: this.searchQuery,
          limit: 20
        })
      } catch (error) {
        if (error === 'canceled') {
          skipFinally = true
          this.loading = true
          return
        }
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        if (!skipFinally) this.loadingAssociated = false
      }
    }
  },
  mounted() {
    this.fetchAssociates()
  }
}
</script>
